import database from "./server.json"
import messages from "./messages"
import validation from "./validation"

export default {...messages,...database, ...validation}